import {collateralOptionsAPI} from '@/api';
import collateralValuationType from '@/constants';
import * as sentry from "@sentry/vue";
import collateralOptions from './collateralOptions';

export default {
    namespaced: true,
    state: {

        yearOptions: [],
        makeOptions: [],
        modelOptions: [],
        trimOptions: [],
        vehicleCollateralOptionSelections: []

    },
    mutations: {

        setData(state, { objName, data }) {
            state[objName] = data;
        },
        resetState(state) {

            state.yearOptions = [];
            state.makeOptions = [];
            state.modelOptions = [];
            state.trimOptions = [];
            state.vehicleCollateralOptionSelections = [];

        }

    },
    actions: {
        async getYearOptionsAsync({ commit, state }, request) {
            try {

                const yearOptions = await collateralOptionsAPI.getYearOptionsAsync(request.collateralValuationType, request.rvCategoryId);

                commit('setData', { objName: 'yearOptions', data: yearOptions });

                return yearOptions;

            } catch (error) {
                throw error;
            }
        },
        async getMakeOptionsAsync({ commit, state }, request) {
            try {

                const makeOptions = await collateralOptionsAPI.getMakeOptionsAsync(request.collateralValuationType, request.year, request.rvCategoryId);

                commit('setData', { objName: 'makeOptions', data: makeOptions });

                return makeOptions;

            } catch (error) {
                throw error;
            }
        },
        async getModelOptionsAsync({ commit, state }, request) {
            try {

                const modelOptions = await collateralOptionsAPI.getModelOptionsAsync(request.collateralValuationType, request.year, request.make, request.rvCategoryId);

                commit('setData', { objName: 'modelOptions', data: modelOptions });

                return modelOptions;

            } catch (error) {
                throw error;
            }
        },
        async getTrimOptionsAsync({ commit, state }, request) {
            try {

                const trimOptions = await collateralOptionsAPI.getTrimOptionsAsync(request.collateralValuationType, request.year, request.make, request.model, request.condition);

                commit('setData', { objName: 'trimOptions', data: trimOptions });

                return trimOptions;

            } catch (error) {
                throw error;
            }
        },
        async getVehicleOptionsAsync({ commit, state }, request) {
            try {

                const vehicleOptions = await collateralOptionsAPI.getVehicleOptionsAsync(request.collateralValuationType, request.year, request.make, request.model, request.bodyStyle, request.condition);

                commit('setData', { objName: 'vehicleOptions', data: vehicleOptions });

                return vehicleOptions;

            } catch (error) {
                throw error;
            }
        },
        async getVinDetailsAsync({commit, state}, request) {
            try {

                return await collateralOptionsAPI.getVinDetailsAsync(request.collateralValuationType, request.vin);

            } catch (error) {
                throw error;
            }
        },
        async updateVehicleCollateralOptionSelectionsAsync({ commit, rootState }, vehicleCollateralOptionSelections) {
            try {
                const applicationId = rootState.application.applicationId;

                const updated = await collateralOptionsAPI.updateVehicleCollateralOptionSelectionsAsync(applicationId, vehicleCollateralOptionSelections);

                commit('setData', { objName: 'vehicleCollateralOptionSelections', data: vehicleCollateralOptionSelections });

                return updated;

            } catch (error) {
                throw error;
            }
        },
		async getVehicleCollateralAsync({ commit, state, rootState }) {
            try {
                const { options } = await collateralOptionsAPI.getVehicleCollateralAsync(
                    rootState.application.applicationId
                );

                commit('setData', { objName: 'vehicleCollateralOptionSelections', data: options || [] });

                return { options };
            } catch (error) {
                throw new Error(error);
            }
        },
    }
}
